import { Box, Flex, Spacer } from "@chakra-ui/layout"
import React from "react"
import styled, { css } from "styled-components"

import Tag from "~/components/atoms/Tag"
import { CampaignRecommendTag, CampaignRequireTag } from "~/components/molecules/CampaignTag"
import ErrorText from "~/components/molecules/ErrorText"
import FormHeading from "~/components/molecules/FormHeading"
import { IsMobile, SpacingSize, Color } from "~/consts/style-mixins"

type Props = {
  label?: string | React.ReactNode
  errorMessage?: string
  isCampaignRequire?: boolean
  isCampaignRecommend?: boolean
  /** childrenの右下に表示する(例えば「100文字」など) */
  extendSpace?: string | React.ReactNode
  isRequired?: boolean
  isOptional?: boolean
}

export const FormContainer: React.FC<Props> = (props) => {
  const { label, errorMessage, children, isCampaignRequire, isCampaignRecommend, extendSpace, isRequired, isOptional } =
    props
  return (
    <Box w="100%">
      <Flex align="center">
        {isRequired && (
          <StyledTag size="Small" color={Color.Attention}>
            必須
          </StyledTag>
        )}
        {isOptional && (
          <StyledTag size="Small" color={Color.LightGray}>
            任意
          </StyledTag>
        )}
        {label && (
          <Box mt={SpacingSize.XS}>
            <FormHeading type="SubHeading" completed>
              {label}
            </FormHeading>
          </Box>
        )}
        <Spacer />
        {isCampaignRequire && <CampaignRequireTag />}
        {isCampaignRecommend && <CampaignRecommendTag />}
      </Flex>

      <StyledContent>{children}</StyledContent>
      {(errorMessage || extendSpace) && (
        <StyledContent hasExtendSpace={extendSpace}>
          {errorMessage && <ErrorText className="error-text">{errorMessage}</ErrorText>}
          {extendSpace && <Box textAlign="right">{extendSpace}</Box>}
        </StyledContent>
      )}
    </Box>
  )
}

const StyledTag = styled(Tag)`
  display: inline-block;
  flex-shrink: 0;
  margin-top: ${SpacingSize.XS}px;
  margin-right: ${SpacingSize._2XS}px;
`

const StyledContent = styled.div<{ hasExtendSpace?: unknown }>`
  position: relative;
  margin-top: ${SpacingSize.XS}px;
  ${({ hasExtendSpace }: any) =>
    hasExtendSpace &&
    css`
      min-height: 10px;
      ${IsMobile(css`
        .error-text {
          max-width: 244px;
        }
      `)}
    `}
`
